// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces/index';
import { Ticket, User, TicketComment } from './zendesk';
import * as e from '../enums/index';

export function enumStringToValue<E>(enumRef: any, value: string): E {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}

export class ListTicketsRequest implements i.ListTicketsRequestInterface {
  partnerId: string;
  cursor: string;

  static fromProto(proto: any): ListTicketsRequest {
    let m = new ListTicketsRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.ListTicketsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.partnerId === 'undefined' && typeof this.cursor === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}

export class ListTicketsResponse implements i.ListTicketsResponseInterface {
  tickets: Ticket[];
  users: User[];
  nextCursor: string;
  hasMore: boolean;
  count: number;

  static fromProto(proto: any): ListTicketsResponse {
    let m = new ListTicketsResponse();
    m = Object.assign(m, proto);
    if (proto.tickets) {
      m.tickets = proto.tickets.map(Ticket.fromProto);
    }
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }

  constructor(kwargs?: i.ListTicketsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.tickets === 'undefined' &&
      typeof this.users === 'undefined' &&
      typeof this.nextCursor === 'undefined' &&
      typeof this.hasMore === 'undefined' &&
      typeof this.count === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.tickets !== 'undefined' && this.tickets !== null) {
      toReturn['tickets'] = 'toApiJson' in this.tickets ? (this.tickets as any).toApiJson() : this.tickets;
    }
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? (this.users as any).toApiJson() : this.users;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}

export class ListCommentsRequest implements i.ListCommentsRequestInterface {
  ticketId: number;

  static fromProto(proto: any): ListCommentsRequest {
    let m = new ListCommentsRequest();
    m = Object.assign(m, proto);
    if (proto.ticketId) {
      m.ticketId = parseInt(proto.ticketId, 10);
    }
    return m;
  }

  constructor(kwargs?: i.ListCommentsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.ticketId === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.ticketId !== 'undefined') {
      toReturn['ticketId'] = this.ticketId;
    }
    return toReturn;
  }
}

export class ListCommentsResponse implements i.ListCommentsResponseInterface {
  comments: TicketComment[];

  static fromProto(proto: any): ListCommentsResponse {
    let m = new ListCommentsResponse();
    m = Object.assign(m, proto);
    if (proto.comments) {
      m.comments = proto.comments.map(TicketComment.fromProto);
    }
    return m;
  }

  constructor(kwargs?: i.ListCommentsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.comments === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.comments !== 'undefined' && this.comments !== null) {
      toReturn['comments'] = 'toApiJson' in this.comments ? (this.comments as any).toApiJson() : this.comments;
    }
    return toReturn;
  }
}

export class SearchTicketsRequest implements i.SearchTicketsRequestInterface {
  partnerId: string;
  searchTerm: string;
  status: e.Status;
  sortBy: e.SortBy;
  cursor: string;
  sortOrder: e.SortOrder;

  static fromProto(proto: any): SearchTicketsRequest {
    let m = new SearchTicketsRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue<e.Status>(e.Status, proto.status);
    }
    if (proto.sortBy) {
      m.sortBy = enumStringToValue<e.SortBy>(e.SortBy, proto.sortBy);
    }
    if (proto.sortOrder) {
      m.sortOrder = enumStringToValue<e.SortOrder>(e.SortOrder, proto.sortOrder);
    }
    return m;
  }

  constructor(kwargs?: i.SearchTicketsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.partnerId === 'undefined' &&
      typeof this.searchTerm === 'undefined' &&
      typeof this.status === 'undefined' &&
      typeof this.sortBy === 'undefined' &&
      typeof this.cursor === 'undefined' &&
      typeof this.sortOrder === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.sortBy !== 'undefined') {
      toReturn['sortBy'] = this.sortBy;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.sortOrder !== 'undefined') {
      toReturn['sortOrder'] = this.sortOrder;
    }
    return toReturn;
  }
}

export class SearchTicketsResponse implements i.SearchTicketsResponseInterface {
  tickets: Ticket[];
  users: User[];
  nextCursor: string;
  hasMore: boolean;
  count: number;

  static fromProto(proto: any): SearchTicketsResponse {
    let m = new SearchTicketsResponse();
    m = Object.assign(m, proto);
    if (proto.tickets) {
      m.tickets = proto.tickets.map(Ticket.fromProto);
    }
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }

  constructor(kwargs?: i.SearchTicketsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.tickets === 'undefined' &&
      typeof this.users === 'undefined' &&
      typeof this.nextCursor === 'undefined' &&
      typeof this.hasMore === 'undefined' &&
      typeof this.count === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.tickets !== 'undefined' && this.tickets !== null) {
      toReturn['tickets'] = 'toApiJson' in this.tickets ? (this.tickets as any).toApiJson() : this.tickets;
    }
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? (this.users as any).toApiJson() : this.users;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}

export class GetUserByPhoneRequest implements i.GetUserByPhoneRequestInterface {
  number: string;

  static fromProto(proto: any): GetUserByPhoneRequest {
    let m = new GetUserByPhoneRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetUserByPhoneRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.number === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.number !== 'undefined') {
      toReturn['number'] = this.number;
    }
    return toReturn;
  }
}

export class GetUserByPhoneResponse implements i.GetUserByPhoneResponseInterface {
  user: User;
  pid: string;

  static fromProto(proto: any): GetUserByPhoneResponse {
    let m = new GetUserByPhoneResponse();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    return m;
  }

  constructor(kwargs?: i.GetUserByPhoneResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.user === 'undefined' && typeof this.pid === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? (this.user as any).toApiJson() : this.user;
    }
    if (typeof this.pid !== 'undefined') {
      toReturn['pid'] = this.pid;
    }
    return toReturn;
  }
}

export class CreateTicketRequest implements i.CreateTicketRequestInterface {
  ticket: Ticket;

  static fromProto(proto: any): CreateTicketRequest {
    let m = new CreateTicketRequest();
    m = Object.assign(m, proto);
    if (proto.ticket) {
      m.ticket = Ticket.fromProto(proto.ticket);
    }
    return m;
  }

  constructor(kwargs?: i.CreateTicketRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.ticket === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.ticket !== 'undefined' && this.ticket !== null) {
      toReturn['ticket'] = 'toApiJson' in this.ticket ? (this.ticket as any).toApiJson() : this.ticket;
    }
    return toReturn;
  }
}

export class CreateTicketResponse implements i.CreateTicketResponseInterface {
  ticket: Ticket;

  static fromProto(proto: any): CreateTicketResponse {
    let m = new CreateTicketResponse();
    m = Object.assign(m, proto);
    if (proto.ticket) {
      m.ticket = Ticket.fromProto(proto.ticket);
    }
    return m;
  }

  constructor(kwargs?: i.CreateTicketResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.ticket === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.ticket !== 'undefined' && this.ticket !== null) {
      toReturn['ticket'] = 'toApiJson' in this.ticket ? (this.ticket as any).toApiJson() : this.ticket;
    }
    return toReturn;
  }
}
